import React from 'react';
import { PieChart, Book, GraduationCap } from 'lucide-react';

const DashboardSidebar = ({ activeTab, onTabChange }) => {
  const tabs = [
    { id: 'Overview', icon: PieChart, label: 'Overview' },
    { id: 'My Content', icon: Book, label: 'My Content' },
    { id: 'Student Progress', icon: GraduationCap, label: 'Student Progress' }
  ];

  return (
    <aside className="w-full md:w-64 bg-gray-50 p-4 sm:p-6 rounded-t-lg md:rounded-l-lg md:rounded-tr-none">
      <div className="flex md:block items-center justify-between mb-4 md:mb-8">
        <h2 className="text-xl font-bold text-[#054581] hidden md:block">Dashboard</h2>
      </div>
      {/* Mobile Navigation */}
      <nav className="md:hidden grid grid-cols-3 gap-1">
        {tabs.map(({ id, icon: Icon, label }) => (
          <button
            key={id}
            className={`flex flex-col items-center justify-center p-2 rounded-lg font-medium transition-colors duration-150 ${
              activeTab === id
                ? 'bg-[#1086a4] text-white'
                : 'text-[#054581] hover:bg-[#1086a4]/10 hover:text-[#1086a4]'
            }`}
            onClick={() => onTabChange(id)}
          >
            <Icon className="w-6 h-6 mb-1 stroke-[1.5]" />
            <span className="text-xs text-center">{label}</span>
          </button>
        ))}
      </nav>
      {/* Desktop Navigation */}
      <nav className="hidden md:flex md:flex-col gap-2 space-y-2">
        {tabs.map(({ id, icon: Icon, label }) => (
          <button
            key={id}
            className={`flex items-center gap-3 text-left px-4 py-3 rounded-lg font-medium transition-colors duration-150 ${
              activeTab === id
                ? 'bg-[#1086a4] text-white shadow-inner'
                : 'text-[#054581] hover:bg-[#1086a4]/10 hover:text-[#1086a4]'
            }`}
            onClick={() => onTabChange(id)}
          >
            <Icon className="w-5 h-5 stroke-[1.5]" />
            <span>{label}</span>
          </button>
        ))}
      </nav>
    </aside>
  );
};

export default DashboardSidebar; 